import React, {useCallback, useEffect, useImperativeHandle, useState, forwardRef} from 'react';
import DroppableList from '../DraggingWrappers/DroppableList';
import styles from "../Merging.module.css";
import DesignProblemItem from "../DesignProblemItem/DesignProblemItem";
import PulsingDivWrapper from "../DraggingWrappers/PulsingDivWrapper";
import {useDispatch} from "react-redux";
import * as actionTypes from '../../../store/actions/actionTypes'

const DesignProblemMergingDisplay = forwardRef(({ patternSelected, fromPattern, toPattern }, ref) => {
    const [fromList, setFromList] = useState([]);
    const [toList, setToList] = useState([]);
    const [draggingTo, setDraggingTo] = useState(false)
    const [draggingFrom, setDraggingFrom] = useState(false)
    const dispatch = useDispatch();


    const existsInToList = useCallback((item) => {
        const setProblems = (probs) => dispatch({
            type: actionTypes.SET_MERGE_MODAL_PROBLEMS,
            problems: probs
        })

        setProblems(toList.map(item => {
            return {...item.problem}
        }))

        return (
            Array.isArray(toList) &&
            item && item.problem &&
            toList.some(f => (+item.problem.design_problem_id === +f.problem.design_problem_id))
        );
    }, [toList, dispatch]);

    const existsInFromList = useCallback((item) => {
        return (
            Array.isArray(fromList) &&
            item && item.problem &&
            fromList.some(f => (+item.problem.design_problem_id === +f.problem.design_problem_id))
        );
    }, [fromList]);

    useEffect(() => {
        if (fromPattern && fromPattern.design_problems) {
            setFromList(fromPattern.design_problems.map((problem, index) => {
                const id = problem.design_problem_id + " - Design Problem"
                const isGrayed = existsInToList({problem: problem})
                return {
                    id,
                    problem,
                    content: <div className={isGrayed ? styles.GrayedOut : ''}>
                        <DesignProblemItem designProblem={problem} orderId={index + 1} fromStyles={!isGrayed} liveEdit/>
                    </div>,
                    index,
                    disableDrag: isGrayed
                }
            }))
        }
    }, [fromPattern, patternSelected, existsInToList]);

    useEffect(() => {
        if (toPattern && toPattern.design_problems) {
            setToList(toPattern.design_problems.map((problem, index) => {
                const id = problem.design_problem_id + " - Design Problem"
                const isGrayed = existsInToList({problem: problem})
                return {
                    id,
                    problem,
                    content: <div className={isGrayed ? styles.GrayedOut : ''}>
                        <DesignProblemItem designProblem={problem} orderId={index + 1}
                                           update={handleExerciseUpdate} isMerging
                                           liveEdit
                        />
                    </div>,
                    index,
                    disableDrag: true
                }
            }))
        }
    }, [toPattern, patternSelected]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleExerciseUpdate = (exercise) => {
        console.log(exercise)
        setToList((prevToList) =>
            prevToList.map((item) => {
                if (+exercise.id === +item.problem.design_problem_id) {
                    return {
                        ...item,
                        problem: {...item.problem, design_problem: exercise.description},
                        content: <div>
                            <DesignProblemItem designProblem={item.problem} orderId={item.index + 1}
                                               update={handleExerciseUpdate} isMerging fromStyles={!item.disableDrag}
                                               liveEdit
                            />
                        </div>,
                    };
                }
                return item;
            })
        );
    }

    const moveItemBetweenLists = (item, start, destination) => {
        if (start === destination) {
            return;
        }
        if (start === 'fromList' && !existsInToList(item)) {
            const newItem = {
                ...item,
                index: toList.length,  // Set the new index here
                content: (
                    <div>
                        <DesignProblemItem
                            designProblem={{ ...item.problem }}
                            orderId={toList.length + 1}  // Use updated orderId
                            update={handleExerciseUpdate}
                            isMerging
                            fromStyles={true}
                            liveEdit
                        />
                    </div>
                )
            };

            setToList((prevToList) => [...prevToList, newItem]);  // Add item to `toList`

            // Recalculate and update `orderId` for all items in `toList`
            setToList((prevToList) => prevToList.map((item, index) => ({
                ...item,
                index,  // Update index
                content: (
                    <div>
                        <DesignProblemItem
                            designProblem={item.problem}
                            orderId={index + 1}  // Reflect updated orderId
                            update={handleExerciseUpdate}
                            isMerging
                            fromStyles={existsInFromList(item)}
                            liveEdit
                        />
                    </div>
                )
            })));
        } else if (start === 'toList' && destination === 'fromList' && existsInFromList(item)) {
            setToList(prev => prev.filter(p => +p.problem.design_problem_id !== +item.problem.design_problem_id))
        }
    };


    useImperativeHandle(ref, () => ({
        getList: () => {
            return toList.map(item => {
                return  {...item.problem}
            });  // Return the current state of toList
        }
    }));

    return (
        <div className={styles.Container}>
            <div className={styles.SplitCols}>
                <h3>Design Problems:</h3>
                <PulsingDivWrapper active={draggingFrom}>
                    <DroppableList
                        list={toList}
                        setList={setToList}
                        itemType={'EXERCISES'}
                        targetListName="toList"
                        moveItemBetweenLists={moveItemBetweenLists}
                        noStyle
                        setDragging={setDraggingTo}
                    />
                </PulsingDivWrapper>
            </div>
            <div className={styles.Separator}></div>
            <div className={styles.SplitCols}>
                <h3>Design Problems:</h3>
                <PulsingDivWrapper active={draggingTo}>
                    <DroppableList
                        list={fromList}
                        setList={setFromList}
                        itemType={'EXERCISES'}
                        targetListName="fromList"
                        moveItemBetweenLists={moveItemBetweenLists}
                        noStyle
                        setDragging={setDraggingFrom}
                    />
                </PulsingDivWrapper>
            </div>
        </div>
    )
});

export default DesignProblemMergingDisplay;
